import Axios from 'axios'
import APP_CONSTANT from '../../../config/constants'

export const getTyrePosition = async () => {
  try {
    let apiToken = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/tyrePosition/?customerNumber=${customerNo}&userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    return data

  } catch (error) {
  }
}

export const getTyreSize = async () => {
  try {
    let apiToken = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/tyreSize?customerNumber=${customerNo}&userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    return data

  } catch (error) {
  }
}

export const getTyreType = async () => {
  try {
    let apiToken = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/tyreType?customerNumber=${customerNo}&userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    return data

  } catch (error) {
  }
}

export const getTyreStatus = async () => {
  try {
    let apiToken = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/tyreStatus?customerNumber=${customerNo}&userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    return data

  } catch (error) {
  }
}

export const getTyreModal = async () => {
  try {
    let apiToken = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/tyreModel?customerNumber=${customerNo}&userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    return data

  } catch (error) {
  }
}

export const getTyreMake = async () => {
  try {
    let apiToken = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/tyreMake?customerNumber=${customerNo}&userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    return data

  } catch (error) {
  }
}

export const getTyreDetails = async (serialNo) => {
  try {
    let apiToken = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')
    let apiURL
    if(serialNo){
      apiURL = `${APP_CONSTANT.BASE_URL}masters/tyre?searchString=${serialNo}&customerNumber=${customerNo}&userId=${userId}`
    }else{
      apiURL = `${APP_CONSTANT.BASE_URL}masters/tyre?customerNumber=${customerNo}&userId=${userId}`
    }
    const { data } = await Axios.get(apiURL , {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": apiToken,
        "Access-Control-Allow-Origin": "*"
      }
    });
    return data

  } catch (error) {
  }
}